


export default class {
    constructor($el, scrollWatcher) {
        this.$ = $el;
        this.scrollWatcher = scrollWatcher;
        this.desktopBg = $el.data('desktop-bg');
        this.mobileBg = $el.data('mobile-bg'); /* could be undefined */
        this.current = null; /* null|'desktop'|'mobile' */
        this.staticBgSet = false;
        scrollWatcher.addBlock(this);
        this.refresh(scrollWatcher.initMargins());
        this.scrollWatcher.windowPal.resize(()=>{
            this.loadBg();
        });
        this.loadBg();
    }
    showDesktopBg() {
        if (this.current !== 'desktop') {
            this.current = 'desktop';
            this.setBg(this.desktopBg);
        }
    }
    showMobileBg() {
        if (this.current !== 'mobile') {
            this.current = 'mobile';
            if (this.mobileBg) {
                this.setBg(this.mobileBg);
            }
        }
    }
    setBg(img) {
        this.$.css('background-image', 'url("'+img+'")');
    }
    refresh(windowMargins) {
        // console.log('block refresh()', this.$[0]);
        let top = parseInt(this.$.offset().top),
            height = parseInt(this.$.outerHeight()),
            bottom = top + height;
        if (
            windowMargins.within('load', top)
            || windowMargins.within('load', bottom)
            || windowMargins.outside('load', top, bottom)
        ) {
            this.loadBg();
        }
        if (
            windowMargins.within('show', top)
            || windowMargins.within('show', bottom)
            || windowMargins.outside('show', top, bottom)
        ) {
            this.$.addClass('-show');
            // console.log('adding .show', this.$[0]);
        }
    }
    loadBg() {
        // console.log('loadBg()', this.$[0]);
        if (this.mobileBg) {
            let windowWidth = this.scrollWatcher.windowPal.$.width();
            if (windowWidth > 950) {
                if (this.isMobile !== false) {
                    this.isMobile = false;
                    this.showDesktopBg();
                }
            } else {
                // console.log('setAsMobile');
                if (this.isMobile !== true) {
                    this.isMobile = true;
                    this.showMobileBg();
                }
            }
        } else if ( ! this.staticBgSet) {
            this.staticBgSet = true;
            this.setBg(this.desktopBg);
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/lib/Block.js